/** Mirror of backend LIBRARY_EXPECTED_RELATIONS for frontend QA */
export const LIBRARY_EXPECTED_RELATIONS = [
  "has_chakra",
  "has_element",
  "has_guna",
  "governed_by_planet",
  "related_story",
  "related_sadhana",
  "related_mantra",
  "related_festival",
];
